import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
export const SearchFilterInstructors = ({ items, onClick }) => {
    return (React.createElement("div", { className: css(styles.instructorCircles) }, items.map((item) => (React.createElement("div", { key: item.id, className: css(styles.instructorItem), onClick: () => onClick(item.id) },
        React.createElement("img", { className: css(styles.instructorImg, item.selected && styles.instructorImgOn), src: item.imageUrl, alt: "", loading: "lazy", decoding: "async" }),
        React.createElement("span", { className: css(styles.instructorName) }, item.name))))));
};
const styles = StyleSheet.create({
    instructorCircles: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        columnGap: '2px',
        rowGap: '16px',
        [MediaBreakPointUp.MD]: {
            gridTemplateColumns: 'repeat(5, 76px)',
            justifyContent: 'center',
            columnGap: '16px',
            rowGap: '16px',
        },
    },
    instructorItem: {
        width: '100%',
        minWidth: 0,
        contentVisibility: 'auto',
        containIntrinsicSize: '64px 98px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        fontSize: 11,
        cursor: 'pointer',
        [MediaBreakPointUp.MD]: {
            width: 76,
            containIntrinsicSize: '76px 98px',
        },
    },
    instructorImg: {
        width: 64,
        height: 64,
        maxWidth: '100%',
        borderRadius: '50%',
        objectFit: 'cover',
        border: '2px solid transparent',
        [MediaBreakPointUp.MD]: {
            width: 72,
            height: 72,
        },
    },
    instructorImgOn: {
        borderColor: Colors.PrimaryDark,
        boxShadow: `inset 0 0 0 100vmax ${Colors.PrimaryTransparentB}`,
    },
    instructorName: {
        width: '100%',
        textAlign: 'center',
        overflowWrap: 'anywhere',
    },
});
